(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[555],{

/***/ 34691:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[...slug]",
      function () {
        return __webpack_require__(51167);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Post; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/common/Layout.js + 17 modules
var Layout = __webpack_require__(58814);
// EXTERNAL MODULE: ./components/blocks/custom/Teaser/index.ts + 1 modules
var Teaser = __webpack_require__(94543);
// EXTERNAL MODULE: ./components/molecules/Blocks/index.js + 149 modules
var Blocks = __webpack_require__(50377);
// EXTERNAL MODULE: ./functions/utils.js
var utils = __webpack_require__(75265);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./components/atoms/Container/index.ts
var Container = __webpack_require__(691);
// EXTERNAL MODULE: ./components/atoms/Icon/index.ts
var Icon = __webpack_require__(16372);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/molecules/Share/Share.module.scss
var Share_module = __webpack_require__(22178);
var Share_module_default = /*#__PURE__*/__webpack_require__.n(Share_module);
;// CONCATENATED MODULE: ./components/molecules/Share/Share.js







function Share() {
    var ref = (0,react.useState)(""), windowLocation = ref[0], setWindowLocation = ref[1];
    (0,react.useEffect)(function() {
        setWindowLocation(window === null || window === void 0 ? void 0 : window.location);
    });
    var copyCurrentUrl = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(windowLocation)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error("Failed to copy URL: ", e);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function copyCurrentUrl() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Share_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Share_module_default()).title,
                    children: "Teilen"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Share_module_default()).iconsWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            target: "_blank",
                            href: "https://www.linkedin.com/shareArticle?mini=true&url=".concat(windowLocation),
                            className: (Share_module_default()).icon,
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                icon: "linkedin"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            target: "_blank",
                            href: "https://www.facebook.com/sharer/sharer.php?u=".concat(windowLocation),
                            className: (Share_module_default()).icon,
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                icon: "facebook"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            target: "_blank",
                            href: "https://twitter.com/intent/tweet?url=".concat(windowLocation),
                            className: (Share_module_default()).icon,
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                icon: "twitter"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            target: "_blank",
                            href: "https://www.xing.com/spi/shares/new?url=".concat(windowLocation),
                            className: (Share_module_default()).icon,
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                icon: "xing"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: function() {
                                return copyCurrentUrl();
                            },
                            className: (Share_module_default()).icon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                icon: "link"
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/blocks/custom/RelatedPosts/index.ts + 1 modules
var RelatedPosts = __webpack_require__(23566);
;// CONCATENATED MODULE: ./pages/news/[...slug].js








var __N_SSG = true;
function Post(param) {
    var post = param.post;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        removeMarginTopFooter: true,
        seo: (0,_object_spread/* default */.Z)({}, post === null || post === void 0 ? void 0 : post.seo),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "innerWrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Teaser/* default */.Z, {
                        block: {
                            title: post.title,
                            image: post === null || post === void 0 ? void 0 : (ref = post.featuredImage) === null || ref === void 0 ? void 0 : ref.node,
                            label: "Blog",
                            titleLabel: (0,utils/* formatDate */.p)(post.date)
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Blocks/* default */.Z, {
                        blocks: post === null || post === void 0 ? void 0 : post.blocks
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Share, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedPosts/* default */.Z, {
                block: {
                    posts: post === null || post === void 0 ? void 0 : post.relatedPosts,
                    title: (post === null || post === void 0 ? void 0 : post.language.code) === "DE" ? "Weitere News" : "More News"
                }
            })
        ]
    });
}


/***/ }),

/***/ 22178:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Share_wrapper__J6IKr","iconsWrapper":"Share_iconsWrapper__Fji4l","icon":"Share_icon__baxex","title":"Share_title__1ZFM9","scale":"Share_scale__ZImCD"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [255,400,74,629,774,888,179], function() { return __webpack_exec__(34691); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);